import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import EnquireForm from "../Home/enquire/EnquireForm";
import { fieldDevelop } from "../Home/enquire/TabContentConfig";
import contactPage from "../../assets/images/contact/contact-page.jpg";
import Layouts from "../helpers/Layouts";
// import background from "../../assets/images/banner/contact_us.jpg";

export default function Contact() {
  const tabContent = useMemo(
    () => [
      {
        id: 1,
        mapID: fieldDevelop,
        uniqKey: "__get_quotation",
        content: "Get Quotation",
      },
    ],
    [fieldDevelop]
  );

  const tabContentData = useMemo(() => {
    const activeTab = tabContent.find((item) => item.id === 1);
    return activeTab ? activeTab.mapID : [];
  }, [tabContent]);

  return (
    <>
      <Layouts
        background="https://nct-social-media-icon.s3.ap-south-1.amazonaws.com/images/banner/contact_us.jpg"
        pageTitle="Contact us"
        breadcrumbs={[
          { name: "home", path: "/" },
          { name: "contact", path: "/contact" },
        ]}
      >
        <section className="contact-page py-120 rpy-100">
          <div className="container">
            <div className="contact-info-area mb-80">
              <div className="contact-info-item wow fadeInUp delay-0-2s">
                <i className="far fa-map"></i>
                <p>B-7, 1st Floor Sector-2, Noida, UP 201301</p>
              </div>
              <div className="contact-info-item wow fadeInUp delay-0-4s">
                <i className="far fa-envelope"></i>
                <p>
                  <a href="mailto:contact@nextcosmostechnology.com">
                    contact@nextcosmostechnology.com
                  </a>{" "}
                  <br />
                  <Link to="/">www.nextcosmostechnology.com</Link>
                </p>
              </div>
              <div className="contact-info-item wow fadeInUp delay-0-6s">
                <i className="fas fa-phone-alt"></i>
                <p>
                  <a href="tel:+91 8851373820">+91 8851373820</a> <br />
                  <a href="whatsappto:+91 8851373820">+91 8851373820</a>
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4">
                <div
                  className="contact-form-left bgs-cover h-100 wow fadeInLeft delay-0-2s"
                  style={{ backgroundImage: `url(${contactPage})` }}
                >
                  <h2>Skip the Small Talk. Let's Solve.</h2>
                </div>
              </div>
              <div className="col-lg-8">
                <div className="contact-form ml-40 rml-0 rmt-55 wow fadeInRight delay-0-2s">
                  <h3 className="comment-title mb-35">Send A Message</h3>
                  <p>
                    You have a goal. We have the strategy. The space between
                    them is just a conversation. Stop wondering "what if" and
                    let's start building "what is." Describe your project below
                    and let’s create something impactful, together.
                  </p>

                  <div id="comment-form" className="comment-form mt-35">
                    <EnquireForm formElements={tabContentData} tab={1} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="contact-page-map">
          <div className="our-location">
            <iframe
              title="map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3071.178408989668!2d77.31073272939312!3d28.58511991465383!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5fb027329d7%3A0x2428fd0d17538198!2sNext%20Cosmos%20Technology%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1688669292849!5m2!1sen!2sin"
              height="650"
              style={{ border: "0", width: "100%" }}
              allowFullScreen=""
              loading="lazy"
              sandbox="allow-scripts allow-presentation"
            ></iframe>
          </div>
        </div>
      </Layouts>
    </>
  );
}
